import * as React from 'react';
import * as classNames from 'classnames';
import defer = require('lodash/defer'); // tslint:disable-line: no-require-imports

interface DropdownButtonState {
	isOpen: boolean;
}

export default class DropdownButton extends React.Component<{}, DropdownButtonState> {

	public state: DropdownButtonState = {
		isOpen: false,
	};

	constructor(props: {}, context: any) {
		super(props, context);
		this.handleClickMenu = this.handleClickMenu.bind(this);
		this.handleClickDocument = this.handleClickDocument.bind(this);
	}

	public componentWillUpdate(nextProps: {}, nextState: DropdownButtonState) {
		if (nextState.isOpen) {
			document.addEventListener('click', this.handleClickDocument);
		} else {
			document.removeEventListener('click', this.handleClickDocument);
		}
	}

	public componentWillUnmount() {
		document.removeEventListener('click', this.handleClickDocument);
	}

	public render() {
		const className = classNames('dropdown-button', {
			'dropdown-button--open': this.state.isOpen,
		});
		const [button, ...options] = React.Children.toArray(this.props.children);
		return <div className={className} onClick={this.handleClickMenu}>
			{button}
			<div className='dropdown-button-menu'>
				{options}
			</div>
		</div>;
	}

	private handleClickMenu(event: React.MouseEvent<HTMLElement>) {
		defer(() => this.setState({isOpen: true}));
	}

	private handleClickDocument() {
		this.setState({isOpen: false});
	}

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./ts/components/util/widgets/DropdownButton.tsx